import {
  Grid,
  TextField
} from '@material-ui/core';
import {
  Dialog
} from 'components';
import { editHoliday } from 'store/firebase';
import { fetchHolidays } from 'store/holiday';
import { useReduxDispatch } from 'store/hooks';
const EditHolidayDialog = ({ isEditOpen, onCloseEdit, draftEdit, onChangeDraft }) => {
  const getHolidayList = useReduxDispatch(fetchHolidays);
  const handleEditHoliday = () => {
    editHoliday(draftEdit).then(() => {
      getHolidayList();
      onCloseEdit();
    })
  };
  return (
    <Dialog
      fullWidth
      title="Ubah Libur"
      open={isEditOpen}
      onClose={() => {
        onCloseEdit();
        onChangeDraft({});
      }}
      action={{
        label: 'Simpan Perubahan',
        onClick: () => handleEditHoliday()
      }}
    >
      <Grid container>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            label='Keterangan'
            InputLabelProps={{
              shrink: true
            }}
            value={draftEdit.title}
            style={{
              marginBottom: '16px'
            }}
            onChange={(e) =>
              onChangeDraft('title', e.target.value)
            }
          />
        </Grid>
      </Grid>
    </Dialog>

  )
}

export default EditHolidayDialog;
